import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { authService } from '../../services/auth.service'

const LogoutPage = () => {
  const navigate = useNavigate()

  useEffect(() => {
    const handleLogout = async () => {
      try {
        await authService.logout()
      } catch (error) {
        console.error('Logout failed:', error)
      } finally {
        navigate('/')
      }
    }
    handleLogout()
  }, [navigate])

  return (
    <div>
      <h1>Logging out...</h1>
      <p>You will be redirected to the home page shortly.</p>
    </div>
  )
}

export default LogoutPage
